// extracted by mini-css-extract-plugin
module.exports = {"container":"UserRow_container__bJZKn","admin":"UserRow_admin__2b9UN","icon":"UserRow_icon__1oNgp"};